export default __webpack_public_path__ + "static/media/home-business-blog-img01.ffbc3f01.jpg";